import { useDispatch, useSelector } from 'react-redux';
import Counter from '../Counter';

import { useEffect, useState } from 'react';
import { IoInformationCircle } from 'react-icons/io5';
import { Card, CardBody, Container, Spinner } from 'reactstrap';
import { VALIDATE_FLIGHT_DETAILS } from '../../../../../../../../store/actions';
import MaxPassengerModal from '../Modals/MaxPassengerModal';
import Marquee from 'react-fast-marquee';

export default function PassengerDetailsForm({
  passengerDetails,
  setPassengerDetails,
  setCurrentActiveForm,
  selectedConfig,
  flightNumber,
  setFlightNumber,
}) {
  const dispatch = useDispatch();

  /* ---------------------------- LOCAL STATES ---------------------------- */
  const [isPressedNext, setIsPressedNext] = useState<boolean>(false);
  const [isShowFlightError, setIsShowFlightError] = useState<boolean>(false);

  const [isShowMaxPassengersCountModal, setIsShowMaxPassengersCountModal] = useState<boolean>(false);

  /* ---------------------------- REDUX STATES ---------------------------- */
  const { flightValidate, flightValidateLoading } = useSelector((state: any) => ({
    flightValidate: state?.GetValidateFlightDetails?.data,
    flightValidateLoading: state?.GetValidateFlightDetails?.loading,
  }));

  useEffect(() => {
    if (flightValidate !== null) {
      if (flightValidate?.result?.isValidated) {
        setIsShowFlightError(false);
        setIsPressedNext(false);

        console.log('hello navigation - ', {
          passengerDetails,
          car: selectedConfig?.carTypes?.[0],
          isPressedNext,
        });

        if (isPressedNext) {
          if (
            passengerDetails?.number_of_passengers + passengerDetails?.number_of_baby_seats + passengerDetails?.number_of_infants >
            selectedConfig?.carTypes?.[0]?.passengers
          ) {
            // setIsShowMaxPassengersCountModal(true);
          } else {
            setCurrentActiveForm(4);
          }
        } else {
          setIsPressedNext(false);
          setIsShowFlightError(false);
        }
      } else {
        setIsPressedNext(false);
        setIsShowFlightError(true);
      }
    }
  }, [flightValidate]);

  const checkFlightValidation = (flightNumber: string, isNext: boolean) => {
    setIsPressedNext(isNext);

    if (flightNumber?.length < 3) {
      setIsShowFlightError(true);
      return;
    } else {
      dispatch({
        type: VALIDATE_FLIGHT_DETAILS,
        payload: {
          urlParams: {
            flight_number: flightNumber,
          },
        },
      });
    }
  };

  return (
    <>
      {/* {isShowMaxPassengersCountModal && (
        <MaxPassengerModal
          onClose={() => setIsShowMaxPassengersCountModal(false)}
          totalPassengerCount={selectedConfig?.carTypes?.[0]?.passengers ?? 0}
        />
      )} */}

      <div className="form-section-passenger-details">
        <h4>Car and Flight details</h4>

        <div className="flight-number-container">
          <input
            type="text"
            className="flight-number"
            maxLength={20}
            name="flight_number"
            id="flight_number"
            placeholder="Enter Flight Number"
            autoComplete="off"
            value={flightNumber}
            onChange={(e: any) => {
              const value = e.target.value?.toUpperCase();
              setFlightNumber(value);
              setIsShowFlightError(false);
            }}
            onBlur={() => {
              setIsPressedNext(false);
              checkFlightValidation(flightNumber, false);
            }}
          />
          {isShowFlightError && (
            <div id="password-error" className="flight-error">
              {flightNumber?.trim() === `` ? 'This field is mandatory and cannot be left empty.' : 'Invalid flight number. Please try again.'}
            </div>
          )}

          {flightValidateLoading && (
            <div className="field-loader">
              <Spinner color="primary" size="sm" />
            </div>
          )}
        </div>

        <Counter passengerDetails={passengerDetails} setPassengerDetails={setPassengerDetails} carDetails={selectedConfig?.carTypes?.[0]} />

        <div className="information-label-container">
          <span className="info-icon">
            <IoInformationCircle />
          </span>
          <span className="info-content">
            The number of luggage allowed for your selected car is {selectedConfig?.carTypes?.[0]?.luggages ?? 0} size medium.{' '}
          </span>
        </div>

        {passengerDetails?.number_of_passengers + passengerDetails?.number_of_baby_seats + passengerDetails?.number_of_infants >
          selectedConfig?.carTypes?.[0]?.passengers && (
          <div className="warning-information-label-container" style={{ marginTop: '160px' }}>
            <Marquee speed={50} gradient={false}>
              Total passengers (number of passengers + baby seats + infants) should not be more than &nbsp;{' '}
              {selectedConfig?.carTypes?.[0]?.passengers ?? 0}.{'    '} &nbsp; &nbsp; &nbsp;
            </Marquee>
          </div>
        )}

        <div
          className={`stepper-form-footer-btn`}
          style={{
            marginTop: `${
              passengerDetails?.number_of_passengers + passengerDetails?.number_of_baby_seats + passengerDetails?.number_of_infants >
              selectedConfig?.carTypes?.[0]?.passengers
                ? '0'
                : '160px'
            }`,
          }}
        >
          <div
            className="stepper-form-footer-btn-secondary"
            onClick={() => {
              setCurrentActiveForm(2);
            }}
          >
            Previous
          </div>
          <div
            className={`stepper-form-footer-btn-primary ${
              passengerDetails?.number_of_passengers + passengerDetails?.number_of_baby_seats + passengerDetails?.number_of_infants >
              selectedConfig?.carTypes?.[0]?.passengers
                ? 'disabled-div '
                : ''
            }`}
            onClick={() => {
              checkFlightValidation(flightNumber, true);
              // setCurrentActiveForm(3);
            }}
          >
            Continue
          </div>
        </div>
      </div>
    </>
  );
}
